<template>
  <section class="subscribe-form-comp form-base">
    <div class="form-base-block">
      <section class="form-base-innerblock">
        <h1>{{ $t('sign-up.subscribe-title') }}</h1>
        <hr>
        <h4>{{ $t('sign-up.subscribe-text') }}</h4>
        <label>{{ $t('sign-up.email-title') }}</label>
        <form class="form-form" name="email-form" data-name="Email Form">
          <input type="email" class="form-input" placeholder="" maxlength="256" name="" id="" required="">

        </form>

        <s-button class="button-primary-blue s-button-round" btn-link="/">{{$t('actions.subscribe-now')}}</s-button>

      </section>
    </div>
  </section>

</template>
<script>
import SButton from "@/components/SButton.vue";

export default {
  name: 'SubscribeForm',
  components: {
    SButton,
  },
  props: {
    msg: String
  }
}
</script>

